import styled from '@emotion/styled';
import { PrimaryButton } from 'components/Button';
import { Container, GridItem } from 'components/Layout';
import { Label } from 'components/PageLayout';
import { Checkbox } from 'components/Checkbox';
import { DatePickerField } from 'components/DatePickerFields';
import { useInMobile } from 'core/Theming/Device';
import {
  renderSearchButtonText,
  renderSearchIcon,
} from 'pages/ReportsDetails/helpers';
import { ReportFormCoreMIProps } from './types';

export const ReportFormCoreMI = ({
  handleSubmit,
  setIsInitialWorkCompletedDate,
  isBusy,
  setStartDate,
  startDate,
  endDate,
  setEndDate,
  isInitialWorkCompletedDate,
}: ReportFormCoreMIProps) => {
  const isMobile = useInMobile();
  return (
    <CustomForm onSubmit={handleSubmit}>
      <Container direction="row">
        <InputButton md={3} sm={4} xs={12}>
          <Label>Start Date</Label>
          <DatePickerField
            isDisabled={isBusy}
            onChange={(date) => setStartDate(date)}
            value={startDate}
            maxDate={endDate}
          />
        </InputButton>
        <InputButton md={3} sm={4} xs={12}>
          <Label>End Date</Label>
          <DatePickerField
            isDisabled={isBusy}
            onChange={(date) => setEndDate(date)}
            value={endDate}
            minDate={startDate}
          />
        </InputButton>
        <InputButton md={2} sm={4} xs={12}>
          <CheckBoxButton>
            <Checkbox
              disabled={isBusy}
              checked={isInitialWorkCompletedDate}
              onChange={(e) =>
                setIsInitialWorkCompletedDate(Boolean(e.target.checked))
              }
              label="Filter by Initial Completed Date"
              color="primary"
            />
          </CheckBoxButton>
        </InputButton>
        <GridItem md={1} sm={1} xs={2}>
          <Button type="submit" disabled={!startDate || !endDate || isBusy}>
            {renderSearchIcon(isMobile)}
            {renderSearchButtonText(isMobile)}
          </Button>
        </GridItem>
      </Container>
    </CustomForm>
  );
};

const InputButton = styled(GridItem)`
    padding-right: ${({ theme }) => theme.margin.s};
    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        margin - bottom: 6px;
    }
    & svg {
        width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.palette.secondary.main};
    }
`;

const CustomForm = styled.form`
  margin-bottom: ${({ theme }) => theme.margin.l};
`;

const Button = styled(PrimaryButton)`
  min-width: 40px;
  font-size: ${({ theme }) => theme.fontSize.s};
  height: 40px;
  padding: 12px;
  margin-top: 20.5px;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    width: 100%;
  }
`;

const CheckBoxButton = styled('div')`
  margin-top: 20px;
`;
